export default function ($) {

    const $search = $('[data-search]');

    if (!$search.length) return;

    const $input = $search.find('[data-search-input]');
    const $results = $search.find('[data-search-results]');
    let timer;
    let lastTerm = '';

    function close() {
        $results.removeClass('is-active').empty();
    }

    function fetch(term) {
        lastTerm = term;
        $results.addClass('is-active').html('<p class="header__main-searched-empty">Zoeken...</p>');

        $.post(ajaxURL, { action: 'search_products', nonce: ajaxNonce, term: term }).done(function (response) {
            if (term !== lastTerm || !response.success) return;

            $results.html(response.data.html);
        });
    }

    $input.on('input', function () {
        const term = $(this).val().trim();

        clearTimeout(timer);

        if (term.length < 2) return close();

        timer = setTimeout(() => fetch(term), 300);
    });

    $input.on('keydown', function (e) {
        if (e.key === 'Escape') close();

        if (e.key === 'Enter') {
            const $first = $results.find('.header__main-searched-result').first();

            if ($first.length && $results.hasClass('is-active')) window.location.href = $first.attr('href');
        }
    });

    $(document).on('click', function (e) {
        if (!$(e.target).closest('[data-search]').length) close();
    });

}
